<template>
	<div class="titleBox">
		<div class="nav">
			<div @click="goIndex" class="ConpName">
				<div class="text1">摩米贝尔</div>
			</div>
			<el-dropdown trigger="click" @command="handleCommand" class="el-dropdown">
			  <span class="el-dropdown-link">
				{{goodName}}<i class="el-icon-arrow-down el-icon--right"></i>
			  </span>
			  <el-dropdown-menu slot="dropdown">
				<el-dropdown-item command='1' style="margin-bottom: 1rem;">首页</el-dropdown-item>
				<el-dropdown-item command='2' style="margin-bottom: 1rem;">适用场景</el-dropdown-item>
				<el-dropdown-item command='3' style="margin-bottom: 1rem;">功能介绍</el-dropdown-item>
				<el-dropdown-item command='4' >合作伙伴</el-dropdown-item>
				<el-dropdown-item command='5' >人才招聘</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown>
			<div @click="goDaili" class="ConpName">
				<div class="text1">合作伙伴</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "mobileNav",
	data (){
		return{
			goodName:'首页',
			commandIdx:''
		}
	},
	methods:{
		handleCommand(command){
			let that = this
			that.commandIdx = command
			if(that.commandIdx==1){
				that.goodName = '首页'
				that.$router.push("/")
			}else if(that.commandIdx==2){
				that.goodName = '适用场景'
				that.$router.push("/scene")
			}else if(that.commandIdx==3){
				that.goodName = '功能介绍'
				that.$router.push("/funs")
			}else if(that.commandIdx==4){
				that.goodName = '合作伙伴'
				that.$router.push("/agent")
			}else if(that.commandIdx==5){
				that.goodName = '人才招聘'
				that.$router.push("/job")
			}
		},
		goDaili(){
			let that = this
			that.$router.push("/agent")
		},
		goIndex(){
			let that = this
			that.$router.push("/")
			that.commandIdx=1
			that.goodName = '首页'
		}
	}
}
</script>

<style>
	.el-dropdown-link{
		cursor: pointer;
	}
	.el-dropdown{
		flex: 1;
		font-size: 2.8rem !important;
		line-height: 4rem;
	}
</style>
